<template>
  <a-card class="main-content">
    <a-tree :selectedKeys="selected" default-expand-all :tree-data="navigate"
      @select="onSelect">
      <template #title="{ dataRef }">
        <i :class="'iconfont ' + dataRef.icon" style="margin-right: 5px;"></i>
        <span>{{ dataRef.title }}</span>
      </template>
    </a-tree>

  </a-card>
</template>
<script setup lang="ts">
const props = withDefaults(defineProps<{
  navigate?: PageNavigate<OrderQuery>[],
  selected?: string[]
}>(), {
  navigate: () => [],
  selected: () => []
})
const emits = defineEmits(['select', 'update:selected'])

const onSelect = (keys: string[]) => {
  let setting: PageNavigate<OrderQuery> | undefined
  props.navigate.some(navigate => {
    const first = navigate.children?.first(a => a.key === keys[0])
    if (!first) return false
    setting = first
    return true
  })

  emits('select', setting)
  emits('update:selected', keys)
}
</script>